module.exports = __webpack_public_path__ + "static/original-mattress-3-5ec8a454eb3ef0adcb28560ef4305c77.png";